import { render, staticRenderFns } from "./HeritageNode.vue?vue&type=template&id=46968a7c&scoped=true"
import script from "./HeritageNode.vue?vue&type=script&lang=ts"
export * from "./HeritageNode.vue?vue&type=script&lang=ts"
import style0 from "./HeritageNode.vue?vue&type=style&index=0&id=46968a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46968a7c",
  null
  
)

export default component.exports